import debug from 'bows/dist/bows.min.js';

let card_links = document.querySelectorAll('.post-card__figure__link, .post-card__title a');
const log = debug("card");

function addCardHover() {
	card_links.forEach(card => {

		card.addEventListener("mouseenter", function () {
			this.closest('.post-card').classList.add('is-hovered');
		});

		card.addEventListener("mouseout", function () {
			this.closest('.post-card').classList.remove('is-hovered');
		});
	});
}

export function init() {
	if (card_links) {
		addCardHover();
	}
}

export default {
	init
};
